<script setup lang="ts"></script>
<template>
  <div class="flex w-full flex-col gap-y-6 md:gap-y-4">
    <slot></slot>
  </div>
</template>
